import { Component, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { SpinnerService } from '../../../services/spinner.service';


@Component({
  selector: 'app-holders-contributions-dis-image-dialog',
  templateUrl: './holders-contributions-dis-image-dialog.component.html',
  styleUrls: ['./holders-contributions-dis-image-dialog.component.scss'],
})
export class HoldersContributionsDisImageDialogComponent implements OnInit {

  scale = 1.6;
  readonly minScale = 1.6;
  readonly maxScale = 5;
  readonly scaleStep = 0.2;

  constructor(
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private dialogRef: MatDialogRef<HoldersContributionsDisImageDialogComponent>,
  ) {
   
  }

  ngOnInit() {

  }

  closeDialog(): void {
    this.dialogRef.close();
  }


  zoomIn(): void {
    if (this.scale < this.maxScale) this.scale += this.scaleStep;
  }

  zoomOut(): void {
    if (this.scale > this.minScale) this.scale -= this.scaleStep;
  }

  resetZoom(): void {
    this.scale = 1.6;
  }

}
